import React, {useState, useEffect} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { Row, Col, Card, CardBody, CardTitle,CardText, Table, UncontrolledTooltip, Container, Button, Alert, Modal } from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import { Link, useHistory } from "react-router-dom"
 import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";

import axios from 'axios';
import { HRConfig, TOAST_OPTIONS, formatDate } from "../../helpers/backend_helper"
import * as url from 'helpers/url_helper';
import { useParams } from 'react-router-dom';

import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Select from 'react-select';
import Swal from 'sweetalert2';
import { Autosave, useAutosave } from 'react-autosave';

import LoadingOverlay from 'react-loading-overlay';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';

    const ApprovePaymentRequisition = () => {
        
        const history = useHistory();
        const {no, id} = useParams();
        const [state, setState] = useState({});

        const [rows1, setrows1] = useState([{ id: 1 }]);
        const [formRows, setFormRows] = useState([{ id: 1 }]);


        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };

        const [inputs, setInputs] = useState([]);
        const [empTitle, setEmpTitle] = useState('');
        const [requisitionerNo, setRequisitionerNo] = useState('')
        const [employeeNo1, setEmployeeNo1] = useState('')

        const [subCategories, setSubCategories] = useState([])
        const [payeeOptions, setPayeeOptions] = useState([])
        const [currencyList, setCurrencyList] = useState([])
        const [accType, setAccType] = useState(['G/L Account', 'Vendor', 'Customer', 'Bank Account'])
       
        const [selectedPayee, setSelectedPayee] = useState('')
        const [paymentCategory, setPaymentCategory] = useState('')
        const [paymentSubCategory, setPaymentSubCategory] = useState('')
        const [purpose, setPurpose] = useState('')
        const [cancellationcomment, setCancellationComment] = useState('')
        const [currencyCode, setCurrencyCode] = useState('')
        const [projectCode, setProjectCode] = useState('')
        const [payeeNo, setPayeeNo] = useState('')
        const [payeeName, setPayeeName] = useState('')
        const [approverCode, setApproverCode] = useState('')
        const [amount, setAmount] = useState('')
        const [amountLCY, setAmountLCY] = useState('')
        // const [no, setNo] = useState('')
        const [status, setStatus] = useState('')

        const [etag, setEtag] = useState('')
        const [systemId, setSystemId] = useState('')

        const [selectedType, setSelectedType] = useState('')
        const [selectedNox, setSelectedNox] = useState('')
        const [description, setDescription] = useState('')
        const [lineEtag, setLineEtag] = useState('')


        const [paymentRequisitionLines, setPaymentRequisitionLines] = useState([])

        const [noo, setNoo] = useState([])
        const [noo1, setNoo1] = useState([])

        const [isloading, setIsloading] = useState(false);
        const [userError, setUserError] = useState(true);
        const [ipaSaved, setIpaSaved] = useState(false)
        const [ipaNo, setIpaNo] = useState('')

        const [showPayeeNo, setShowPayeeNo] = useState(false)

        const [modal_line, setmodal_line] = useState(false);
        const [modal_applyEntries, setmodal_applyEntries] = useState(false);
        const [isEdit, setIsEdit] = useState(false)
        const [editLine, setEditLine] = useState(false);
        const [addDetails, setAddDetails] = useState(false);
        const [managementActivities, setManagementActivities] = useState([])

        const [rNo, setRNo] = useState("")
        const [departmentcode, setDepartmentCode] = useState('')
        const [RStatus, setRStatus] = useState("")
        const [empNo, setEmpNo] = useState('');
        const [empName, setEmpName] = useState('');
        const [CompanyID, setCompanyID] = useState("")

        const [payeeType, setPayeeType] = useState('')
        const [selectedNo, setSelectedNo]= useState('')
        const [selectedNo2, setSelectedNo2]= useState('')
        const [workplanno, setWorkPlanNo] = useState("") 
        const [workplans, setWorkPlans] = useState([]) 
        const [transactionTypeslist, setTransactionTypesList] = useState([]) 
        const [externalDocumentNo, setExternalDocumentNo] = useState("")
        const [activityStartDate, setActivityStartDate] = useState("")
        const [activityEndDate, setActivityEndDate] = useState("")

        const [accountType, setAccountType] = useState("")
        const [accountNo, setAccountNo] = useState("")
        const [accountName, setAccountName] = useState("")
        const [customers, setCustomers] = useState([])
        const [wkPlanGLAccounts, setWorkPlanGLAccounts] = useState([])
        const [nonwkPlanGLAccounts, setNonWorkPlanGLAccounts] = useState([])
        const [bankAccounts, setBankAccounts] = useState([])
        const [workPlanEntry, setWorkPlanEntry] = useState([])
        const [narration, setNarration] = useState("")
        const [rate, setRate] = useState(0)
        const [quantity, setQuantity] = useState("")
        const [workPlanEntryNo, setWorkPlanEntryNo] = useState("")
        const [whtpercentage, setWHTPercentage] = useState("")
        const [whtamount, setWHTAmount] = useState("")
        const [lineSystemId, setLineSystemId] = useState("")
        const [whtAmountOnVAT, setWHTAmountonVAT] = useState("")
        const [vatAmount, setVATAmount] = useState("")
        const [amountToPay, setAmounttoPay] = useState("")
        const [amountPaid, setAmountPaid] = useState("")
        const [noOfInstallments, setNoofInstallments] = useState("")
        const [installmentAmount, setInstallmentAmount] = useState("")

        const [applnID, setApplnID] = useState("")
        const [applyEntry, setApplyEntry] = useState(false)
        const [applnPostingDate, setApplnPostingDate] = useState("")
        const [applnDocumentType, setApplnDocumentType] = useState("")
        const [applnDocumentNo, setApplnDocumentNo] = useState("")
        const [applnExtDocNo, setApplnExtDocNo] = useState("")
        const [applnDescription, setApplnDescription] = useState("")
        const [applnCurrencyCode, setApplnCurrencyCode] = useState("")
        const [remainingAmount, setRemainingAmount] = useState("")
        const [applnReminingAmount, setApplnRemainingAmount] = useState("")

        const [showApproveBtn, setShowApproveBtn] = useState(true);
        const [showRejectBtn, setShowRejectBtn] = useState(false);
        const [comment, setComment] = useState('')

        const [loadingFiles, setLoadingFiles] = useState(false)
        const [selectedFile, setSelectedFile] = useState([])
        const [uploadedFiles, setUploadedFiles] = useState([])

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }

        const tog_line = () => {
            setmodal_line(!modal_line);
            removeBodyCss();
        }

        const tog_PlanningSpecifications = () => {
            axios.get(`${url.PLANNINGSPECIFICATIONS}?$filter=documentNo eq '${rNo}'and workplanNo eq '${workplanno}'and workplanEntry eq ${workPlanEntryNo} and purchaseLineNo eq ${lineNo} &company='${CompanyID}'`, HRConfig).then((r)=>{ 
                setManagementActivities(r.data.value) 
            }).catch((e)=>{
                console.log(e)
            })
            setmodal_PlanningSpecifications(!modal_PlanningSpecifications);
            removeBodyCss();
        }

        toastr.options = TOAST_OPTIONS;

        const fetchItemWorkplanEntryNo = (newNo) => {
            axios.get(url.ITEMS + "?$filter=no eq '"+ newNo +"'&company="+ CompanyID, HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        setGLControlAccount(response.data.value[0].GLControlAccount)
                        axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`, HRConfig).then((r)=>{
                            setWorkPlanEntry(r.data.value);
                            }).catch((e)=>{ 
                                console.log(e); 
                                setIsloading(false) 
                        })
                }
            })
        }

        const fetchGLWorkplanEntryNo = (newNo) => {
            axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`, HRConfig).then((r)=>{
                setWorkPlanEntry(r.data.value);
                }).catch((e)=>{ 
                    console.log(e); 
                    setIsloading(false) 
                })
        }

        const fetchFAWorkplanEntryNo = (newNo) => {
            axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${newNo}' &company=${CompanyID}`, HRConfig).then((r)=>{
                setWorkPlanEntry(r.data.value);
                }).catch((e)=>{ 
                    console.log(e); 
                    setIsloading(false) 
                })

                axios.get(url.FIXEDASSETS + "?$filter=no eq '"+ newNo +"'&company="+ CompanyID, HRConfig)
                .then(function(response){
                    if(response.data.value.length > 0){
                        setGLControlAccount(response.data.value[0].GLControlAccount)
                        axios.get(`${url.WORKPLANENTRYNO}?$filter=workPlanNo eq '${workplanno}' and gLAcccount eq '${response.data.value[0].GLControlAccount}' &company=${CompanyID}`, HRConfig).then((r)=>{
                            setWorkPlanEntry(r.data.value);
                            }).catch((e)=>{ 
                                console.log(e); 
                                setIsloading(false) 
                        })
                }
            })
        }

        const handleChange = (event) => {
             const name = event.target.name;
             const value = event.target.value;
             setInputs(values => ({...values, [name]: value}));
        }
        
        const handleNoChange = (e)=>{
            setSelectedNo(e.value); 
            if(selectedType == 'Item'){
                fetchItemWorkplanEntryNo(e.value);
            }
            if(selectedType == 'G/L Account'){
                fetchGLWorkplanEntryNo(e.value);
            }
            if(selectedType == 'Fixed Asset'){
                fetchFAWorkplanEntryNo(e.value);
            }
        }

        // const fetchWorkplanGLAccounts = async() => {
        //     axios.get(`${url.WORKPLANGLACCOUNTS}?$filter=workPlanNo eq '${workplanno}' &company=${CompanyID}`, HRConfig).then((r)=>{
        //         let options = []
        //         r.data.value.map((a)=>{options.push({value:a.gLAcccount, label:`${a.accountName}`})})
        //         setNoo(options);
        //         setWorkPlanGLAccounts(options);
               
        //         if(wkPlanGLAccounts.length > 0) { setIsloading(false) }
        //         setIsloading(false)
        //         }). catch((e)=>{ 
        //             console.log(e)
        //             setIsloading(false) 
        //     })
        // }
        
        const handleActionChange = () =>{
            const selectedAction = document.getElementsByClassName('prAction')[0].value;
                if(selectedAction == 'APPROVE'){
                    setShowApproveBtn(true)
                    setShowRejectBtn(false)
                }else if(selectedAction == 'REJECT'){
                    setShowApproveBtn(false)
                    setShowRejectBtn(true)
                }
        }
        const handleRejectPR = () =>{
            setIsloading(true)
            const lNo = {
                "no": rNo, 
                "rejectionComment":comment
            }
            axios.post(url.REJECTPMTREQN+'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){ 
                    if(response.status == '204'){
                        toastr.info("Payment requisition approval request rejected");
                        history.push(`/payment-approvals`)
                        setIsloading(false) 
                    }else{
                        toastr.error("Could not reject payment requisition" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    console.log(error)
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
            })  
        }

        const fetchCustomers2 = async() => {
            axios.get(`${url.CUSTOMERS}?$filter=no eq '${selectedNo2}' &company=${CompanyID}`, HRConfig).then((r)=>{
                let options = []
                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                setNoo(options);
                setCustomers(options);
                if(customers.length > 0) { setIsloading(false) }
                setIsloading(false)
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
        }

        const fetchWorkplanGLAccounts = async() => {
            axios.get(`${url.WORKPLANGLACCOUNTS}?$filter=workPlanNo eq '${workplanno}' &company=${CompanyID}`, HRConfig).then((r)=>{
                let options = []
                r.data.value.map((a)=>{options.push({value:a.gLAcccount, label:`${a.accountName}`})})
                setNoo(options);
                setWorkPlanGLAccounts(options);
                if(wkPlanGLAccounts.length > 0) { setIsloading(false) }
                setIsloading(false)
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
        }

        const fetchBankAccounts = async() => {
            axios.get(url.BANKACCOUNTS +"?company=" +CompanyID, HRConfig).then((r)=>{     
                let options = []
                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                setNoo(options);
                setBankAccounts(options);
                if(bankAccounts.length > 0) { setIsloading(false) }
                setIsloading(false)
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
        }

        const fetchNonWorkplanGLAccounts = async() => {
            axios.get(`${url.GLACCOUNTS}?$filter=directPosting eq true and nonWorkPlanEntry eq true &company=${CompanyID}`, HRConfig).then((r)=>{
                let options = []
                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                setNoo(options);
                setNonWorkPlanGLAccounts(options);
                if(nonwkPlanGLAccounts.length > 0) { setIsloading(false) }
                setIsloading(false)
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
        }

        const handleApprovePR = () =>{
            setIsloading(true)
            const lNo = {'no': no}
            axios.post(url.APPROVEPMTREQN +'?company='+CompanyID, JSON.stringify(lNo), HRConfig)
                .then(function(response){     
                    if(response.status == '200'){
                        toastr.success("Payment requisition approved successfully!" );
                        history.push(`/payment-approvals`) 
                    }else{
                        toastr.error("Could not Approve payment requisition" )
                    }
                    setIsloading(false)
                })
                .catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setIsloading(false)
                })
        }

        const handleTypeChange = (e) =>{
            setSelectedType(e.target.value)
            setIsloading(true)
            if(e.target.value == 'Item'){
                setNoo(items)
                if(items.length > 0){ setIsloading(false) }
            }else if(e.target.value == 'G/L Account'){
                // setNoo(gLAccounts)
                // if(gLAccounts.length > 0){ setIsloading(false) }
                fetchWorkplanGLAccounts()
            }else if(e.target.value == 'Fixed Asset'){
                setNoo(fixedAssets)
                if(fixedAssets.length > 0) { setIsloading(false) }
            }else{
                setNoo([])
                setIsloading(false)
            }
        }

        const updateexpectedDeliveryDate = (e) => {
            let newexpdeldate = (e)
            if ((e != '')){
                let req = {}
                req = {
                    expectedDeliverytDate  : e
                }
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.PURCHASES1}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                    .then(function(response){     
                        if(response.status == '200'){
                            toastr.success("Saved" );
                            setExpectedDeliveryDate(newexpdeldate) 
                        }else{
                            toastr.error("Could not save Expected Delivery date" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }
        
        const updateexpectedReceiptDate = (e) => {
            let newexprecdate = (e)
            if ((e != '')){
                let req = {}
                req = {
                    expectedReceiptDate  : e
                }
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.PURCHASES1}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                    .then(function(response){     
                        if(response.status == '200'){
                            toastr.success("Saved" );
                            setExpectedReceiptDate(newexprecdate) 
                        }else{
                            toastr.error("Could not save Expected Receipt date" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }

        const handlePayeeTypeChange = (type) =>{
            
            setSelectedPayee(null)
            //setPayeeNo('')
            //setPayeeName('')
            setPayeeOptions([])
            setAccType(['G/L Account'])
            let options = []
            if(type == ""){
                setShowPayeeNo(false)
            }else{
                setShowPayeeNo(true)
            }
            // if(type == "Customer"){
            //     setAccType(['G/L Account', 'Customer'])
            //     setIsloading(true)
            //     axios.get(`${url.PAYEETYPE_CUSTOMER}`, HRConfig).then((r)=>{ 
            //         r.data.value.map((v)=>{
            //             options.push({'label': v.customerName,'value':v.customerNo})
            //         })
            //         setPayeeOptions(options)
            //         setIsloading(false)
            //     }).catch((e)=>{ 
            //         console.log(e)
            //         setIsloading(false)
            //     })
            // }
            // if(type == "Vendor"){
            //     setAccType(['Vendor'])
            //     setIsloading(true)
            //     axios.get(`${url.PAYEETYPE_VENDOR}`, HRConfig).then((r)=>{ 
            //         r.data.value.map((v)=>{
            //             options.push({'label': v.vendorName,'value':v.vendorNo})
            //         })
            //         setPayeeOptions(options)
            //         setIsloading(false)
            //     }).catch((e)=>{ 
            //         console.log(e)
            //         setIsloading(false)
            //     })
            // }
            // if(type == "Bank"){
            //     setAccType(['Bank Account'])
            //     setIsloading(true)
            //     axios.get(`${url.PAYEETYPE_BANK}`, HRConfig).then((r)=>{ 
            //         r.data.value.map((v)=>{
            //             options.push({'label': v.bankName,'value':v.bankNo})
            //         })
            //         setPayeeOptions(options)
            //         setIsloading(false)
            //     }).catch((e)=>{ 
            //         console.log(e)
            //         setIsloading(false)
            //     })
            // }
            // if((type == "Employee")){
            //     setAccType(['G/L Account'])
            //     setIsloading(true)
            //     axios.get(`${url.PAYEETYPE_IMPREST}`, HRConfig).then((r)=>{ 
            //         r.data.value.map((v)=>{
            //             options.push({'label': v.customerName,'value':v.customerNo})
            //         })
            //         setPayeeOptions(options)
            //         setIsloading(false)
            //     }).catch((e)=>{ 
            //         console.log(e)
            //         setIsloading(false)
            //     })
            // }
            // if((type == "Imprest")){
            //     setAccType(['G/L Account'])
            //     setIsloading(true)
            //     axios.get(`${url.PAYEETYPE_IMPREST}`, HRConfig).then((r)=>{ 
            //         r.data.value.map((v)=>{
            //             options.push({'label': v.customerName,'value':v.customerNo})
            //         })
            //         setPayeeOptions(options)
            //         setIsloading(false)
            //     }).catch((e)=>{ 
            //         console.log(e)
            //         setIsloading(false)
            //     })
            // }
        }

        const updateProcurementType = (e) => {
            let newform = e.target.value
            if ((e.target.value != '')){
                let req = {}
                req = {
                    procurementType  : e.target.value
                }
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.PURCHASES1}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                    .then(function(response){     
                        if(response.status == '200'){
                            toastr.success("Saved" );
                            setForm(newform) 
                        }else{
                            toastr.error("Could not save Procurement type" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }

        const updateLocationCode = (e) => {
            let newlocation = e.target.value
            if ((e.target.value != '')){
                let req = {}
                req = {
                    locationCode  : e.target.value
                }
                toastr.info("Saving...")
                const Config = {
                    auth: {
                        username: url.HRMIS,
                        password: url.HRMISPASS,
                    },
                    headers: {
                        'Content-Type': 'application/json',
                        'If-Match'    : '*'
                    }
                }
                axios.patch(`${url.PURCHASES1}(${id})?company=${CompanyID}`, JSON.stringify(req), Config)
                    .then(function(response){     
                        if(response.status == '200'){
                            toastr.success("Saved" );
                            setLocationCode1(newlocation) 
                        }else{
                            toastr.error("Could not save Location code" )
                        }
                        setIsloading(false)
                    })
                    .catch(function (error) {
                        toastr.error(error.response.data.error.message);
                        setIsloading(false)
                    }
                )
            }
        }
         
        const fetchFA = async() => {
            axios.get(url.FIXEDASSETS+"?company=" + CompanyID, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.description}`})})  
                setFixedAssets(options)
                setNoo(options)
                }).catch((e)=>{ 
                    console.log(e)
            })
            setIsloading(false)
        }

        const fetchItms = async() => {
            axios.get(url.ITEMS +"?company=" + CompanyID, HRConfig).then((r)=>{ 
                let options = []
                r.data.value.map((a)=>{options.push({value:a.no, label:`${a.description}`})}) 
                setItems(options)
                setNoo(options)
                }).catch((e)=>{ 
                    console.log(e)
            })
            setIsloading(false)
        }

        const clearLineData = () =>{
            setSelectedType('');
            setSelectedNo('')
            setWorkPlanEntryNo('')
            setDescription2('')
            setQuantity('')
            setDirectUnitCost('')
            setLineSystemId('')
        }
        const handleClickLineDetails = (k) =>{
            const p = paymentRequisitionLines[k]
            setIsEdit(true)
            setIsloading(true)
            tog_line()
            setAccountType(p.accountType)
            setAccountNo(p.accountNo)
            setAccountName(p.accountName)
            setQuantity(p.quantity)
            setRate(p.rate)
            setAmount(p.amount)
            setAmountLCY(p.amountLCY)
            setNarration(p.narration)
            fetchGLWorkplanEntryNo(p.accountNo)
            setWorkPlanEntryNo(p.workPlanEntryNo)
            setLineSystemId(p.id)
            setWHTPercentage(p.whtPercentage)
            setWHTAmount(p.whtAmount)
            setWHTAmountonVAT(p.whtAmountOnVAT)
            setVATAmount(p.vatAmount)
            setAmounttoPay(p.amountToPay)
            setAmountPaid(p.amountPaid)
            setInstallmentAmount(p.installmentAmount)
            setNoofInstallments(p.noOfInstallments)

            if(p.accountType == 'Item'){
                fetchItms()
                setIsloading(false)
            }else if(p.accountType == 'G/L Account'){
                fetchWorkplanGLAccounts()
                setIsloading(false)
            }else if(p.accountType == 'None Workplan- G/L'){
                fetchNonWorkplanGLAccounts()
                setIsloading(false)
            }else if(p.accountType == 'Fixed Asset'){
                fetchFA()
                setIsloading(false)
            }else{
                setNoo([])
                setIsloading(false)
            }
            
        }
        useEffect(() => {
           getData() 
        },[]);

      const getData = () =>{
        let obj = JSON.parse(localStorage.getItem("authMildUser"));
        let EmployeeNo = obj.uid;
        const navUserName = obj.username
        setCompanyID(obj.activeCompany);
        setEmployeeNo1(obj.uid)
        setIsloading(true)
        axios.get(`${url.PAYMENTS1}?$filter=no eq '${no}'&$expand=paymentRequisitionLines&company='${obj.activeCompany}'`, HRConfig)  
        .then(function(r){
            setRNo(r.data.value[0].no)
            setEmpNo(r.data.value[0].requisitioner)
            setEmpName(r.data.value[0].requisitionerName)
            setRStatus(r.data.value[0].status)
            setActivityStartDate(r.data.value[0].activityStartDate)
            setActivityEndDate(r.data.value[0].activityEndDate)
            setWorkPlanNo(r.data.value[0].workPlanNo)
            setPayeeType(r.data.value[0].payeeType)
            setSelectedNo(r.data.value[0].transactionType)
            setSelectedNo2(r.data.value[0].payeeNo)
            setExternalDocumentNo(r.data.value[0].externalDocumentNo)
            setRequisitionerNo(r.data.value[0].requisitioner)

            setAmount(r.data.totalAmount)
            setPaymentRequisitionLines(r.data.value[0].paymentRequisitionLines)
            setPaymentCategory(r.data.paymentCategory)
            
            if(r.data.payeeNo != ""){
                setShowPayeeNo(true)
            }
            setPayeeName(r.data.value[0].payeeName)
            setPayeeNo(r.data.value[0].payeeNo)
            setPurpose(r.data.value[0].purpose)
            setProjectCode(r.data.value[0].projectCode)
            //setNo(r.data.value[0].paymentReqNo)
            setStatus(r.data.value[0].Status)
            setPaymentCategory(r.data.value[0].paymentCategory)
            setPaymentSubCategory(r.data.value[0].paySubcategory)             
            handlePayeeTypeChange(r.data.value[0].payeeType)
            setCurrencyCode(r.data.value[0].currencyCode)

            axios.get(`${url.EMPLOYEES2}?$filter=No eq '${r.data.value[0].requisitioner}'&company=${obj.activeCompany}`, HRConfig).then((response)=>{
                setEmpTitle(response.data.value[0].JobTitle);
                setDepartmentCode(response.data.value[0].Department_Code)                  
                setUserError(false);
                setIsloading(false)
                }).catch(function (error) {
                    toastr.error(error.response.data.error.message);
                    setUserError(true);
                    console.log(error);
                    setIsloading(false)
            }) 
            axios.get(`${url.WORKPLANS}?$filter=department eq '${r.data.value[0].shortcutDim2Value}' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                setWorkPlans(r.data.value);
                }).catch((e)=>{ 
                    console.log(e); 
                    setIsloading(false) 
            })
            if(r.data.value[0].payeeType == 'Staff'){
                axios.get(`${url.CUSTOMERS}?$filter=customerPostingGroup eq 'STAFF' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                    let options = []
                    r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                    setNoo1(options);
                    setIsloading(false)
                    }). catch((e)=>{ 
                        console.log(e)
                        setIsloading(false) 
                })
            }
            if(r.data.value[0].payeeType == 'Salary Advance'){
                axios.get(`${url.EMPLOYEES2}?$filter=Status eq 'Active' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                    let options = []
                    r.data.value.map((a)=>{                      
                        options.push({value:a.No, label:`${a.FirstName} ${a.LastName}`})
                    })
                    setNoo1(options);
                    setIsloading(false)
                    }). catch((e)=>{ 
                        console.log(e)
                        setIsloading(false) 
                })
            }
            if(r.data.value[0].payeeType == 'Vendor'){
                axios.get(url.VENDORS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{
                    let options = []
            r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
            setNoo1(options);
            setIsloading(false)
            }). catch((e)=>{ 
                console.log(e)
                setIsloading(false) 
        })
            }
            if(r.data.value[0].payeeType == 'Subgrantee'){
                axios.get(`${url.CUSTOMERS}?$filter=customerPostingGroup eq 'SUB-OVC' or customerPostingGroup eq 'SUB PNFPS' or customerPostingGroup eq 'SUB DIST' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                    let options = []
                    r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                    setNoo1(options);
                    setIsloading(false)
                    }). catch((e)=>{ 
                        console.log(e)
                        setIsloading(false) 
                })
            }
            if(r.data.value[0].payeeType == 'Bank Transfers'){
                axios.get(url.BANKACCOUNTS +"?company=" + obj.activeCompany, HRConfig).then((r)=>{
                    let options = []
                    r.data.value.map((a)=>{options.push({value:a.no, label:`${a.name}`})})
                    setNoo1(options);
                    setIsloading(false)
                    }). catch((e)=>{ 
                        console.log(e)
                        setIsloading(false) 
                })
            }
            axios.get(`${url.REQNTRANSACTIONTYPE}?$filter=transactionType eq '${r.data.value[0].payeeType}' &company=${obj.activeCompany}`, HRConfig).then((r)=>{
                setTransactionTypesList(r.data.value);
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
            axios.get(url.CURRENCIES +"?company=" + obj.activeCompany, HRConfig).then((r)=>{
                setCurrencyList(r.data.value);
                }). catch((e)=>{ 
                    console.log(e)
                    setIsloading(false) 
            })
            axios.get(`${url.ATTACHDOCUMENTS}?$filter=DocumentType eq 'Payment Requisition' and No eq '${r.data.value[0].no}' &company=${obj.activeCompany}`, HRConfig).then((rx)=>{
                setUploadedFiles(rx.data.value)
                setLoadingFiles(false)
                }).catch((ex)=>{ 
                    console.log(ex); 
                    setLoadingFiles(false) 
            })
            
        }).catch((e)=>{
            setIsloading(false)
            console.log(e)
        })
    }
        useEffect(() => {
            getData()
            return () => {
                setState({}); 
              };
        },[]);

        
        return (
      
            <LoadingOverlay
                active={isloading}
                spinner={<ClimbingBoxLoader />}
                text='Please wait...'
                >
                <div className="page-content">
                    <MetaTags>
                    <title>Payment Requisition Details | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Payment Management" breadcrumbItem="Payment Requisition" />
                        <div>
                        {userError && ( 
                        <Alert color="danger" role="alert">
                                Details Not Found in Dynamics 365 Business Central
                        </Alert>
                        )}

                        {(ipaSaved == false) ? (
                        <Row>
                            <Col xl={4}>
                            <Card>
                                <CardBody>
                                    <CardTitle>Employee Details</CardTitle>
                                        <div className="table-responsive">
                                            <table className="table">
                                                <tbody>
                                                    <tr>
                                                        <th scope="col"> Number</th>
                                                        <td scope="col"> {empNo} </td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col"> Name</th>
                                                        <td scope="col">{empName}</td>
                                                    </tr>
                                                    <tr>
                                                        <th scope="col">Position</th>
                                                        <td scope="col">{empTitle}</td>
                                                    </tr>
                                                    <tr>
                                                    <th scope="col">Department</th>
                                                    <td scope="col">{departmentcode}</td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>                                                      
                                </CardBody>
                            </Card>

                            <Card>
                            <CardBody>
                                <CardTitle>Attachments</CardTitle>
                                {loadingFiles ? (
                                    <>
                                        <div className="text-center">
                                            <div className="mb-4"></div>
                                            <div>
                                                <h5>Loading files ...</h5>
                                                <p className="text-muted"></p>
                                            </div>
                                        </div>
                                    </>
                                ): ((uploadedFiles.length > 0)?(
                                    <div className="table-responsive">
                                            <Table className="table table-striped table-sm mb-4">
                                                <thead>
                                                    <tr>
                                                        <th>File</th>
                                                        <th></th>                                                      
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {uploadedFiles.map((a,k)=>(
                                                        <tr key={k}>                                                          
                                                            <td style={{ verticalAlign: 'middle' }}>
                                                            <Link to="#" onClick={()=>handleDownload(uploadedFiles[k])}>{a.FileName}</Link></td>
                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                <div className="d-flex gap-3">
                                                                {(RStatus == 'Open') && (
                                                                    <Link
                                                                    to="#"
                                                                    className="text-danger"
                                                                    onClick={() => removeFile(uploadedFiles[k])}
                                                                    >
                                                                    <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
                                                                    <UncontrolledTooltip placement="top" target="deletetooltip">
                                                                        Delete
                                                                    </UncontrolledTooltip>
                                                                    </Link>
                                                                    )}
                                                                </div>
                                                                </>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </Table>
                                        </div>
                                        ):(
                                            <div className="text-center">
                                                <div className="mb-4">
                                                <i className="mdi mdi-file text-warning display-4" />
                                                </div>
                                                <div>
                                                <h5>No files attached</h5>
                                                <p className="text-muted">                                                 
                                                </p>
                                                </div>
                                            </div>
                                        )
                                    )}
                                </CardBody>
                            </Card>

                            <div className="d-flex">
                                <div className="flex-grow-1 ms-1">                                 
                                    <ul className="list-unstyled vstack gap-2 mb-0">
                                        <div className="d-grid gap-2">
                                            <Col md={12}>
                                                <div className="mb-3">
                                                <label htmlFor="floatingSelectGrid"> Select Action</label>
                                                    <select  className="form-select prAction" onChange={handleActionChange}>
                                                        
                                                        <option value="APPROVE">APPROVE PAYMENT REQUISITION</option>
                                                        <option value="REJECT">REJECT PAYMENT REQUISITION</option>
                                
                                                    </select>
                                                    
                                                </div>
                                            </Col>
                                            {showRejectBtn && (
                                                <div className="form-floating mb-3">
                                                    <input  type="text" className="form-control" onChange={(e)=>setComment(e.target.value)}  />
                                                    <label htmlFor="floatingSelectGrid"> Rejection Comment</label>
                                                </div>
                                            )}
                                            {showRejectBtn && (
                                            <Col md={12} className="reject">
                                                <div className="d-grid gap-2">
                                                    <Button color="danger" type="button" className="btn btnRejectRequest" onClick={handleRejectPR}>
                                                        <i className="mdi mdi-cancel"/>{" "}
                                                            Reject Payment Requisition
                                                    </Button>
                                                </div>
                                            </Col>
                                            )}
                                            {showApproveBtn && (
                                            <Col md={12} className="approve">
                                                <div className="d-grid gap-2">
                                                    <Button color="primary" type="button" className="btn btnApproveRequest" onClick={handleApprovePR}>
                                                        <i className="mdi mdi-check-circle-outline text-success"/>{" "}
                                                            Approve Payment Requisition
                                                    </Button>
                                                </div>
                                            </Col>
                                            )}
                                        </div>
                                    </ul>
                                </div>
                            </div>    
                        </Col>
                        <Col  xl={8}>
                        <Card>
                        <CardBody>
                            <CardTitle>Requisition Details</CardTitle>
                            <Row>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>Requisition No</label>
                                        <input  type="text" className="form-control" defaultValue={rNo} disabled={true}/>
                                    </div>
                                </Col>
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>Payee Type</label>
                                        <select className="form-select" 
                                            value={payeeType} 
                                            onChange={(e)=>updatePayeeType(e)}
                                            disabled={(RStatus=='Open')?false:true}
                                        >
                                            <option value=" ">Select</option>
                                            <option value="Staff">Staff</option>
                                            <option value="Vendor">Vendor</option>
                                            <option value="Subgrantee">Subgrantee</option>
                                            <option value="Statutory Bodies">Statutory Bodies</option>
                                            <option value="OVC">OVC</option>
                                            <option value="Participants">Participants</option>
                                            <option value="Bank Transfers">Bank Transfers</option>
                                            <option value="Salary Advance">Salary Advance</option>
                                        </select>
                                    </div>
                                </Col>
                                {((payeeType == 'Staff')||(payeeType == 'Vendor')||(payeeType == 'Subgrantee')||(payeeType == 'Statutory Bodies')||(payeeType == 'OVC')||(payeeType == 'Participants')||(payeeType == 'Bank Transfers')||(payeeType == 'Salary Advance')) && (
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Transaction Type</label>
                                            <div className="form-floating mb-3">
                                                <select className="form-select" 
                                                    value={selectedNo}                                                                 
                                                    onChange={(e)=>updateTransactionType(e)}
                                                    disabled={(RStatus=='Open')?false:true}
                                                > 
                                                <option value=''>Select</option>
                                                    { transactionTypeslist.map((l,k)=>( <option key={k} value={l.no}>{l.description}
                                                </option> ))}
                                                </select>
                                            </div>
                                        </div>
                                    </Col>
                                )}
                                {((payeeType == 'Staff')||(payeeType == 'Vendor')||(payeeType == 'Subgrantee')||(payeeType == 'Statutory Bodies')||(payeeType == 'OVC')||(payeeType == 'Participants')||(payeeType == 'Bank Transfers')||(payeeType == 'Salary Advance')) && ((selectedNo == 'SALARIES')||(selectedNo != 'SPECIALISTS')) && (RStatus == 'Open') && (
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Select Payee</label>
                                            <div className="form-floating mb-3">
                                                <Select options={noo1} 
                                                    value={noo1.find((option) => option.value === selectedNo2)} 
                                                    onChange={(p)=>handleSelectedPayee(p)}
                                                    disabled={(RStatus=='Open')?false:true}
                                                />
                                            </div>
                                        </div>
                                    </Col>
                                )} 
                                {(RStatus == 'Open') && (                                          
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Payee No.</label>
                                            <input  type="text" 
                                                className="form-control" 
                                                defaultValue={selectedNo2}
                                                disabled={(RStatus=='Open') && ((selectedNo != 'SALARIES') || (selectedNo != 'SPECIALISTS'))?true:false}
                                            />
                                        </div>
                                    </Col>
                                )}
                                {(RStatus == 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Payee Name</label>
                                            <input  type="text" 
                                                className="form-control" 
                                                value={payeeName} 
                                                onChange={(e)=>setPayeeName(e.target.value)}
                                                disabled={(RStatus=='Open') && (selectedNo != 'SALARIES') && (selectedNo != 'SPECIALISTS')?true:false}
                                            />
                                        </div>
                                    </Col>
                                )}
                                {(RStatus != 'Open') && (                                          
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Payee No.</label>
                                            <input  type="text" 
                                                className="form-control" 
                                                defaultValue={selectedNo2}
                                                disabled={true}
                                            />
                                        </div>
                                    </Col>
                                )}
                                {(RStatus != 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Payee Name</label>
                                            <input  type="text" 
                                                className="form-control" 
                                                value={payeeName} 
                                                onChange={(e)=>setPayeeName(e.target.value)}
                                                disabled={true}
                                            />
                                        </div>
                                    </Col>
                                )}
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>Work Plan No.</label>
                                        <select className="form-select" 
                                            value={workplanno} 
                                            onChange={(e)=>handleChangeWorkPlanNo(e)}
                                            disabled={(RStatus=='Open')?false:true}
                                            > 
                                            <option value=''>Select</option>
                                                { workplans.map((l,k)=>( <option key={k} value={l.no}>{l.no}
                                            </option> ))}
                                        </select>
                                    </div>
                                </Col>
                                
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>External Document No.</label>
                                        <input type='text' 
                                            className="form-control" 
                                            value={externalDocumentNo} 
                                            onChange={(e)=>setExternalDocumentNo(e.target.value)}
                                            disabled={(RStatus=='Open')?false:true}
                                        />
                                    </div>
                                </Col>
                                {(RStatus == 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Activity Start Date</label>
                                            { <Flatpickr
                                                className="form-control"
                                                value={activityStartDate}
                                                onChange={(e)=>updateActivityStartDate(formatDate(e))}                       
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                
                                                }}
                                            /> }
                                        </div>
                                    </Col>
                                )}
                                {(RStatus == 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Activity End Date</label>
                                            { <Flatpickr
                                                className="form-control"
                                                value={activityEndDate}
                                                onChange={(e)=>updateActivityEndDate(formatDate(e))}                       
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"

                                                }}
                                            /> }
                                        </div>
                                    </Col>
                                )}
                                {(RStatus != 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Activity Start Date</label>
                                            { <Flatpickr
                                                className="form-control"
                                                value={activityStartDate}
                                                onChange={(e)=>updateActivityStartDate(formatDate(e))}  
                                                disabled={true}                     
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                
                                                }}
                                            /> }
                                        </div>
                                    </Col>
                                )}
                                {(RStatus != 'Open') && ( 
                                    <Col md={6}>
                                        <div className="mb-3">
                                            <label>Activity End Date</label>
                                            { <Flatpickr
                                                className="form-control"
                                                value={activityEndDate}
                                                onChange={(e)=>updateActivityEndDate(formatDate(e))} 
                                                disabled={true}                      
                                                options={{
                                                    altInput: true,
                                                    altFormat: "F j, Y",
                                                    dateFormat: "Y-m-d"
                                                }}
                                            /> }
                                        </div>
                                    </Col>
                                )}
                                <Col md={6}>
                                    <div className="mb-3">
                                        <label>Currency Code</label>
                                        <select className="form-select" 
                                            value={currencyCode}                                                                 
                                            onChange={(e)=>updatecurrencyCode(e)}
                                            disabled={(RStatus=='Open')?false:true}
                                            > 
                                            <option value=''>Select</option>
                                                { currencyList.map((l,k)=>( <option key={k} value={l.code}>{l.code}
                                            </option> ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col md={12}>
                                    <div className="mb-3">
                                        <label>Purpose</label>
                                        <textarea
                                            type="text" 
                                            className="form-control"
                                            rows={2} 
                                            value={purpose} 
                                            onChange={(e)=>setPurpose(e.target.value)} 
                                            disabled={(RStatus=='Open')?false:true}
                                        />
                                    </div>
                                </Col>
                                
                            </Row>
                        </CardBody>
                        </Card>
                        </Col>
                        <Col lg={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle>Payment Lines and Costing</CardTitle>                         
                                    {(paymentRequisitionLines.length > 0) ? (
                                    <div className="table-responsive">
                                        <Table className="table table-striped table-sm mb-4">
                                            <thead>
                                                <tr>
                                                    <th>Account Type</th>
                                                    <th>Account No</th>
                                                    <th>Work Plan Entry No</th>
                                                    <th>Account Name</th>
                                                    <th>Qty</th>
                                                    <th>Rate</th>
                                                    <th>Amount</th>
                                                    <th>Amount to Pay</th>
                                                    <th>Action</th>
                                                    <th></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {paymentRequisitionLines.map((a,k)=>(
                                                    <tr key={k}>
                                                        <td>{a.accountType}</td>
                                                        <td>{a.accountNo}</td>
                                                        <td>{a.workPlanEntryNo}</td>
                                                        <td>{a.accountName}</td>
                                                        <td style= {{ verticalAlign: 'middle', textAlign: 'center' }}>{a.quantity}</td>
                                                        <td style= {{ verticalAlign: 'middle', textAlign: 'center' }}>{a.rate}</td>
                                                        <td style= {{ verticalAlign: 'middle', textAlign: 'center' }}>{a.amount}</td>
                                                        <td style= {{ verticalAlign: 'middle', textAlign: 'center' }}>{a.amountToPay}</td>
                                                        <td> <>
                                                        {/* {(RStatus == 'Open') && ( */}
                                                        {(rNo != '') && (
                                                            <div className="d-flex gap-3">
                                                                <Link
                                                                    to="#"
                                                                    className="text-success"
                                                                    onClick={()=>handleClickLineDetails(k)}
                                                                >
                                                                <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                    <UncontrolledTooltip placement="top" target="edittooltip">
                                                                        Edit
                                                                    </UncontrolledTooltip>
                                                                </Link>
                                                                
                                                            </div>
                                                        )}

                                                        <Col>        
                                                            <Modal isOpen={modal_line} toggle={() => { tog_line() }} size="xl" centered  backdrop={'static'} >
                                                            <div className="modal-header">
                                                                <h5 className="modal-title mt-0" id="myModalLabel">{isEdit?`View `:`View ` }Payment Requisition Line</h5>
                                                                <button type="button"
                                                                    onClick={() => { setmodal_line(false)}}
                                                                    className="close"
                                                                    data-dismiss="modal"
                                                                    aria-label="Close">
                                                                    <span aria-hidden="true">&times;</span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">     
                                                                <Row >
                                                                    {(payeeType == 'Vendor') && (
                                                                        <Col lg={6}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange(e)}}
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="Vendor">Vendor</option>
                                                                                </select>
                                                                            </div>   
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Staff') && ((selectedNo == 'BUSINESS ADVANCE') || (selectedNo == 'PERDIEM') || (selectedNo == 'PREPAID EXPENSE') || (selectedNo == 'REFUNDS') || (selectedNo == 'VOLUNTEER')) && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="G/L Account">G/L Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'OVC') && (workplanno != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="G/L Account">G/L Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Salary Advance') && (workplanno != '') && (selectedNo != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="G/L Account">G/L Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Participants') && (workplanno != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange2(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="G/L Account">G/L Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Staff') && ((selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange3(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Statutory Bodies') && (selectedNo != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange3(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Subgrantee') && (selectedNo != '') && (workplanno != '') && (selectedNo2 != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange4(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="Customer">Customer</option>
                                                                                    <option value="G/L Account">G/L Account</option>
                                                                                    <option value="None Workplan- G/L">None Workplan- G/L</option>
                                                                                    <option value="Bank Account">Bank Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(payeeType == 'Bank Transfers') && (selectedNo != '') && (selectedNo2 != '') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Type</label>
                                                                                <select className="form-select"  
                                                                                    value={accountType}
                                                                                    onChange={(e) =>{handleAccountTypeChange5(e)}}                                                        
                                                                                    disabled={(RStatus=='Open')?false:true}
                                                                                >
                                                                                    <option value=" ">Select</option>
                                                                                    <option value="Bank Account">Bank Account</option>
                                                                                </select>
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Staff') && ((accountType != '') || (accountType != " ")) && ((selectedNo == 'BUSINESS ADVANCE') || (selectedNo == 'PERDIEM') || (selectedNo == 'PREPAID EXPENSE') || (selectedNo == 'REFUNDS') || (selectedNo == 'VOLUNTEER') || (selectedNo == 'SALARIES') || (selectedNo == 'SPECIALISTS')) && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3"
                                                                                disabled={(RStatus=='Open')?false:true}>
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Bank Transfers') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Salary Advance') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Subgrantee') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'OVC') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Participants') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (payeeType == 'Statutory Bodies') && (   
                                                                        <Col lg={4}>
                                                                            <label htmlFor="floatingSelectGrid">Account Name</label>
                                                                                <div className="form-floating mb-3">
                                                                                    <Select options={noo} 
                                                                                        value={noo.find((option) => option.value === accountNo)} 
                                                                                        onChange={handleNoChange} 
                                                                                    />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(accountType == 'Vendor') && (
                                                                        <Col lg={6}>
                                                                            <div className="mb-3">
                                                                                <label>Account No </label>
                                                                                <input className="form-control" 
                                                                                    value={accountNo} 
                                                                                    disabled={true} />   
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus == 'Open') && (accountType == 'Vendor') && (
                                                                        <Col lg={12}>
                                                                            <div className="mb-3">
                                                                                <label>Account Name </label>
                                                                                <input className="form-control" 
                                                                                    value={accountName} 
                                                                                    disabled={true} />   
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus != 'Open') && (accountType == 'Vendor') && (
                                                                        <Col lg={12}>
                                                                            <div className="mb-3">
                                                                                <label>Account Name </label>
                                                                                <input className="form-control" 
                                                                                    value={accountName} 
                                                                                    disabled={true} />   
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(RStatus != 'Open') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account Name </label>
                                                                                <input className="form-control" 
                                                                                    value={accountName} 
                                                                                    disabled={true} />   
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(accountType != 'Vendor') && (
                                                                        <Col lg={4}>
                                                                            <div className="mb-3">
                                                                                <label>Account No. </label>
                                                                                <input className="form-control" 
                                                                                    value={accountNo} 
                                                                                    disabled={true} />   
                                                                            </div>
                                                                        </Col>
                                                                    )}
                                                                    {(accountType != 'Vendor') && (
                                                                        <Col lg={4} className="mb-3">
                                                                            <label htmlFor="floatingSelectGrid">Workplan Entry No</label>
                                                                            <select className="form-select" value={workPlanEntryNo} onChange={(e)=>setWorkPlanEntryNo(e.target.value)} disabled={(RStatus=='Open')?false:true}> 
                                                                                <option value=''>Select</option>
                                                                                    { workPlanEntry.map((l,k)=>( <option key={k} 
                                                                                        value={l.entryNo}>{l.entryNo}
                                                                                </option> ))}
                                                                                </select>
                                                                        </Col>
                                                                    )}
                                                                    {(accountType != 'Vendor') && (
                                                                        <Col lg={8}> 
                                                                            <label htmlFor="floatingSelectGrid">Narration</label>
                                                                                <div className="mb-3">
                                                                                    <input  type="text" className="form-control" value={narration} onChange={(e)=>setNarration(e.target.value)} disabled={(RStatus=='Open')?false:true}  />
                                                                                </div>
                                                                        </Col>
                                                                    )}
                                                                    {(accountType == 'Vendor') && (
                                                                        <Col lg={12}>
                                                                            <label htmlFor="floatingSelectGrid">Narration</label>
                                                                                <div className="mb-3">
                                                                                    <input  type="text" className="form-control" value={narration} onChange={(e)=>setNarration(e.target.value)} disabled={(RStatus=='Open')?false:true}  />
                                                                                </div>  
                                                                        </Col>
                                                                    )}
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Quantity</label>
                                                                            <div className="mb-3">  
                                                                                <input  type="number" className="form-control" value={quantity}  onChange={(e)=>{ setQuantity(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Rate</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={rate} onChange={(e)=>{ setRate(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                    <label htmlFor="floatingSelectGrid">Amount</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={amount} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                    <label htmlFor="floatingSelectGrid">Amount LCY</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={amountLCY} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">WHT Percentage</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={whtpercentage} onChange={(e)=>{ setWHTPercentage(e.target.value)}} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">WHT Amount</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={whtamount} onChange={(e)=>{ setWHTAmount(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">WHT Amount on VAT</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={whtAmountOnVAT} onChange={(e)=>{ setWHTAmountonVAT(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">VAT Amount</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={vatAmount} onChange={(e)=>{ setVATAmount(e.target.value)}} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Amount to Pay</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={amountToPay} onChange={(e)=>{ setAmounttoPay(e.target.value)}} disabled={(RStatus=='Open')?false:true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Amount Paid</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={amountPaid} onChange={(e)=>{ setAmountPaid(e.target.value)}} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">No. of Installments</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={noOfInstallments} onChange={(e)=>{ setNoofInstallments(e.target.value)}} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Installment Amount</label>
                                                                        <div className="mb-3">
                                                                            <input  type="number" className="form-control" value={installmentAmount} onChange={(e)=>{ setInstallmentAmount(e.target.value)}} disabled={true} />
                                                                        </div>
                                                                    </Col>
                                                                </Row>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <div className="hstack gap-2 mb-0">
                                                                    {(payeeType == 'Vendor') && (
                                                                    <Button color="info" type="button" className="btn btnSubmitPlan" onClick={()=>{tog_applyEntries()}} >
                                                                        <i className="mdi mdi-cash-refund"/>{" "}
                                                                            Apply Entries
                                                                    </Button>
                                                                    )}
                                                                    {(RStatus == 'Open') && (
                                                                        <Button color="danger" type="button" className="btn btnSubmitPlan" onClick={()=>{handleDeleteLine2()}} >
                                                                            <i className="mdi mdi-delete"/>{" "}
                                                                                Delete line
                                                                        </Button>
                                                                    )}
                                                                </div>                                             
                                                            </div>
                                                            </Modal>

                                                            {/* EHUB LOOK ALIVE */}
                                                            <Modal isOpen={modal_applyEntries} toggle={() => { tog_applyEntries(); }}  size="xl" centered  backdrop={'static'}  >
                                                                <div className="modal-header">
                                                                    <h5 className="modal-title mt-0" id="myModalLabel">Apply Vendor Entries - {payeeNo} · {payeeName}</h5>
                                                                    <button type="button"  onClick={() => { setmodal_applyEntries   (false) }}  className="close" data-dismiss="modal"aria-label="Close">
                                                                        <span aria-hidden="true">&times;</span>
                                                                    </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <Row >
                                                                    {(RStatus == 'Open') && addDetails && (
                                                                    <>
                                                                    <Col lg={3}>
                                                                        <div className="mb-3">
                                                                            <label>Select Entry</label>
                                                                            <select className="form-select" 
                                                                                value={applyEntry? 'true' : 'false'} 
                                                                                onChange={(e)=>updateApplyEntry(e)}
                                                                                disabled={(RStatus=='Open')?false:true}
                                                                            >
                                                                                <option value={``}>Select</option>
                                                                                <option value={true}>Yes</option>
                                                                                <option value={false}>No</option>
                                                                            </select>
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label>Posting Date</label>
                                                                        <div className="form-floating mb-3">
                                                                            <Flatpickr
                                                                                className="form-control"
                                                                                disabled={true}
                                                                                placeholder="dd M,yyyy"
                                                                                options={{
                                                                                    altInput: true,
                                                                                    altFormat: "F j, Y",
                                                                                    dateFormat: "Y-m-d"
                                                                                }}
                                                                                value={applnPostingDate}
                                                                            />
                                                                        </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Document Type</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnDocumentType}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Document No.</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnDocumentNo}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">External Document No.</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnExtDocNo}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Currency Code</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnCurrencyCode}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Remaining Amount</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={remainingAmount}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={3}>
                                                                        <label htmlFor="floatingSelectGrid">Application Remaining Amount</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnReminingAmount}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>
                                                                    <Col lg={12}>
                                                                        <label htmlFor="floatingSelectGrid">Description</label>
                                                                            <div className="form-floating mb-3">
                                                                                <input type="text" 
                                                                                    className="form-control" 
                                                                                    value={applnDescription}
                                                                                    disabled={true}  
                                                                                />
                                                                            </div>
                                                                    </Col>                                        
                                                                    </>
                                                                    )}
                                                                    <Col sm={12}>
                                                                        <h5 className="text-primary">- View details</h5>
                                                                        <hr/>
                                                                    </Col>
                                                                    <Col lg={12}>
                                                                        {(managementActivities.length > 0) ? (
                                                                        <div className="table-responsive">
                                                                            <Table  className="table table-striped table-wrap table-sm mb-4">
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th>Select Entry</th>
                                                                                        <th>Applies-to ID</th>
                                                                                        <th>Posting Date</th>
                                                                                        <th>Document Type</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Document No.</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Ext. Document No.</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Description</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Currency</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Remaining Amt</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Application Remaining Amt</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}>Action</th>
                                                                                        <th style={{ verticalAlign: 'middle', textAlign: 'center' }}></th>
                                                                                        
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {managementActivities.map((a,k)=>(
                                                                                        <tr key={k}>
                                                                                            <td>
                                                                                                {a.applyEntry ? <i className='mdi mdi-check'></i> : <i className='mdi mdi-close'></i>}
                                                                                            </td>
                                                                                            <td>{a.appliesToID}</td>
                                                                                            <td>{a.postingDate}</td>
                                                                                            <td>{a.documentType}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.documentNo}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.externalDocNo}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.description}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.curCode}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.remainingAmount}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}>{a.applnremainingAmount}</td>
                                                                                            <td style={{ verticalAlign: 'middle', textAlign: 'center' }}> <>
                                                                                                
                                                                                            {(RStatus == 'Open') && (
                                                                                                <div className="d-flex gap-3">
                                                                                                    <Link
                                                                                                        to="#"
                                                                                                        className="text-success"
                                                                                                        onClick={() => handleEditManagement(k)}
                                                                                                    >
                                                                                                    <i className="mdi mdi-pencil font-size-18" id="edittooltip" />
                                                                                                        <UncontrolledTooltip placement="top" target="edittooltip">
                                                                                                            Edit
                                                                                                        </UncontrolledTooltip>
                                                                                                    </Link>
                                                                                                </div>
                                                                                            )}
                                                                                            </></td>
                                                                                        </tr>
                                                                                    ))}
                                                                                </tbody>
                                                                            </Table>
                                                                            </div>
                                                                        ):(
                                                                            <div className="text-center">
                                                                                <div className="mb-4">
                                                                                <i className="mdi mdi-cash-refund text-warning display-4" />
                                                                                </div>
                                                                                <div>
                                                                                <h5>No Vendor Ledger Entries found</h5>
                                                                                <p className="text-muted">
                                                                                        
                                                                                </p>
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </Col>
                                                                    <Row className='justify-content-center'>
                                                                        {(managementActivities.length > 0) && (
                                                                            <>
                                                                                <Col md={6} className='mb-4 mt-3'>
                                                                                    <div className="d-grid">
                                                                                        <Button color="primary" type="button" className="btn-rounded" onClick={handleAppliestoID}>
                                                                                            Set Applies-to ID
                                                                                        </Button>
                                                                                    </div>
                                                                                </Col>
                                                                                <Col md={6} className='mb-4 mt-3'>
                                                                                    <div className="d-grid">
                                                                                        <Button color="warning" type="button" className="btn-rounded" onClick={handleUnapplyEntries}>
                                                                                            Un-Apply Entries
                                                                                        </Button>
                                                                                    </div>
                                                                                </Col>
                                                                            </>
                                                                        )}
                                                                    </Row>
                                                                </Row>
                                                            </div>
                                                            </Modal>  
                                                        </Col>
                                                        </></td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                        </div>
                                    ):(
                                        <div className="text-center">
                                            <div className="mb-4">
                                            <i className="mdi mdi-check-circle-outline text-warning display-4" />
                                            </div>
                                            <div>
                                            <h5>No details found</h5>
                                            <p className="text-muted">
                                                    
                                            </p>
                                            </div>
                                        </div>
                                    )}
                                </CardBody>
                            </Card>                
                        </Col>
                    <Col>             
                    <br/>
            </Col>
        </Row>
        ):(
            <Row className="d-flex justify-content-center">
                <Col lg={8} >
                    <Card outline color="success" className="border">
                        <CardBody>
                            <div className="text-center">
                                <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                </div>
                                <div>
                                    <h5>Saved</h5>
                                    <p className="text-muted">
                                            Requisition <strong>{rNo}</strong> Saved!
                                    </p>
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )}
        </div>
        </Container>
    </div>
    </LoadingOverlay>
    );
}

export default ApprovePaymentRequisition;